var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dl", [
    _c("dt", [_vm._v("申送事項(継続)")]),
    _vm._v(" "),
    _c("dd", { domProps: { textContent: _vm._s(_vm.transferInformation) } }),
    _vm._v(" "),
    _c("dt", { staticClass: "comment" }, [_vm._v("申送事項(単発)")]),
    _vm._v(" "),
    _c("dd", {
      staticClass: "comment",
      domProps: { textContent: _vm._s(_vm.comment) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ecae406", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ecae406","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/parts/Information.vue
// module id = null
// module chunks = 